import script from "./homeView.vue?vue&type=script&setup=true&lang=js"
export * from "./homeView.vue?vue&type=script&setup=true&lang=js"

import "./homeView.vue?vue&type=style&index=0&id=24d835de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24d835de"]])

export default __exports__